import { Box as MuiBox, withStyles } from '@material-ui/core';

export const Box = withStyles(theme => ({
  root: {
    ...theme.typography.h5,
    display: 'inline-block',
  },
}))(MuiBox);
